

















import { Component, Prop, Vue } from 'vue-property-decorator';
import CanBeSizedMixin from '../mixins/CanBeSizedMixin.vue';
import { ApiModel, CameraModel } from '../models/Product';

@Component
export default class ProductItem extends CanBeSizedMixin {
  @Prop() private product!: ApiModel;
  @Prop() private active!: ApiModel;
  @Prop() private elementHeight!: number;
  private hovering = false;

  private get height() {
    return this.elementHeight + 16;
  }
  private select(pk: string) {
    this.$emit('selected', pk);
  }
  private get ImageUrl() {
    let sizeTemplate = '&height=80';
    let inactiveColor = 'eeeee9';
    if (this.product.type === 'Camera') {
      sizeTemplate = ((this.product as any) as CameraModel).SizeTemplate;
      inactiveColor = 'f3f3ec';
    }
    const color = this.active || this.hovering ? 'ffffff' : inactiveColor;
    const image = this.product.image == null ? 'TX0YDA' : this.product.image;
    return `https://images.medianord.de/erez3/erez?src=Bilder/${image}.tif&tmp=dk-${this.Size}&path=Freisteller&clipcolor=${color}${sizeTemplate}`;
  }
}
